'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dispatch = require('./core/dispatch');

var _dispatch2 = _interopRequireDefault(_dispatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MiddlewareManager() {
  this.chain = [_dispatch2.default, undefined];
}

MiddlewareManager.prototype.use = function (mw) {
  var request = mw.request;
  if (request) {
    if (typeof request !== 'function') {
      this.chain.unshift(request.fulfilled, request.rejected);
    } else {
      this.chain.unshift(request, undefined);
    }
  }

  var response = mw.response;
  if (response) {
    if (typeof response !== 'function') {
      this.chain.push(response.fulfilled, response.rejected);
    } else {
      this.chain.push(response, undefined);
    }
  }
};

MiddlewareManager.prototype.run = function (ctx) {
  var promise = Promise.resolve(ctx);
  var pos = 0;
  while (pos < this.chain.length) {
    var fulfilled = this.chain[pos];
    var rejected = this.chain[pos + 1];
    promise = promise.then(fulfilled).catch(rejected);
    pos += 2;
  }

  return promise;
};

exports.default = MiddlewareManager;